import React from 'react';
import { LocalServicePage } from '../../components/LocalServicePage';

export const LocksmithUpminster = () => {
  return (
    <LocalServicePage
      areaName="Upminster"
      areaType="City"
      slug="locksmith-upminster"
      heroTitle="Door, Window & Lock Specialists in Upminster"
      heroSubtitle="Royal Security provides expert repairs for doors, windows, and locks throughout Upminster. From period properties to modern executive homes, we deliver quality workmanship and honest service."
      introContent={
        <>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Upminster combines village charm with excellent transport links, attracting families and professionals who invest in their properties. We work with homeowners across Upminster who value quality—both in their homes and in the tradespeople they choose.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Our service covers all door, window, and lock repairs. Whether you have traditional timber windows that need sensitive attention, standard uPVC that requires maintenance, or modern aluminium bi-folds that have developed a fault, we have the expertise and parts to help.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            We believe in doing things properly. That means taking time to diagnose issues correctly, explaining your options honestly, and using quality components that will last. Upminster homeowners appreciate this approach—it's why many of our customers here come through recommendations from neighbours and friends.
          </p>
        </>
      }
      servicesEmphasis={[
        {
          title: "Multipoint Lock Specialists",
          description: "Upminster's composite and uPVC doors rely on multipoint locking mechanisms for security. We diagnose and repair these systems—gearboxes, hooks, rollers, and handles. When replacement is needed, we fit quality mechanisms that perform reliably."
        },
        {
          title: "High-Specification Door Repairs",
          description: "Many Upminster properties feature high-quality entrance doors—composite, hardwood, or aluminium. We work on all types, handling lock systems, hinges, handles, and hardware with the care these installations deserve."
        },
        {
          title: "Aluminium & Bi-Fold Door Services",
          description: "Aluminium framed windows, bi-fold doors, and sliding systems are increasingly common in Upminster homes. We repair mechanisms, replace hardware, adjust tracking, and maintain these systems to factory standards."
        },
        {
          title: "Window Mechanism Repairs",
          description: "Casement windows, tilt and turn systems, and sash windows all have mechanisms that can fail. We repair friction stays, espagnolettes, tilt hardware, spiral balances, and all types of window fittings."
        },
        {
          title: "Sealed Unit Replacement",
          description: "When double glazing fails—condensation between panes, visible misting, or seal breakdown—we replace the glass unit within your existing frame. Options include upgrading to improved thermal or acoustic glass."
        },
        {
          title: "Security Upgrades",
          description: "If you're concerned about security, we can assess your current doors and windows and recommend practical improvements. Better locks, additional security features, and upgraded hardware can significantly improve protection."
        }
      ]}
      localContextTitle="Looking After Bi-Fold, French & Patio Doors in Upminster"
      localContext={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Keep tracks clean:</strong> Grit and debris in the bottom track can make bi-folds and patio doors heavy or noisy. Vacuum the track regularly, wipe it with a damp cloth, and follow the manufacturer's guidance on any lubricant.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Check the alignment:</strong> If a bi-fold panel catches when folding, or French doors no longer meet evenly in the middle, the hinges or rollers may have moved out of adjustment. This can often be adjusted rather than replaced—we'll confirm on inspection.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            <strong>Locks that need force:</strong> If you have to push or lift the door to lock it, get it looked at before the mechanism fails. Forcing a multipoint lock on a misaligned door can damage the gearbox and leave a door that won't open.
          </p>
        </>
      }
      commonProblems={[
        {
          title: "Bi-fold doors not folding smoothly",
          description: "Track alignment, roller condition, and hinge adjustment all affect operation. We diagnose and resolve the specific issue."
        },
        {
          title: "Composite door expanding in summer",
          description: "Composite doors can be affected by temperature changes. Adjustment and sometimes component replacement resolves this."
        },
        {
          title: "High-security lock not functioning",
          description: "Premium lock systems have sophisticated mechanisms. We repair and replace to maintain your security level."
        },
        {
          title: "Patio door hard to slide",
          description: "Worn rollers, dirty tracks, or misalignment. We service the door to restore easy operation."
        },
        {
          title: "Windows not sealing properly",
          description: "Gaskets, seals, and compression need checking. Often resolved with adjustment and seal replacement."
        },
        {
          title: "Door handles tarnished or dated",
          description: "We supply and fit quality replacement handles in various styles to refresh your door's appearance."
        }
      ]}
      whyChooseUs={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Upminster homeowners expect quality, and we deliver it. Our engineers understand the difference between a quick fix and a proper repair. We take time to do the job right, use appropriate parts, and leave your property as we found it—clean and tidy.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Our diagnosis-first approach is particularly valued by customers with higher-specification installations. We won't default to replacing expensive components if repair is viable. Equally, we'll tell you honestly if something needs replacement rather than attempting a repair that won't last.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            Being locally based means we're accessible for follow-up and ongoing maintenance. Many Upminster customers use us regularly—annual checks on doors and windows, addressing minor issues before they become major problems, and knowing they have a reliable tradesperson to call.
          </p>
        </>
      }
      ctaText="Looking for Quality Door & Window Services in Upminster?"
    />
  );
};
